
export default function AboutSection() {
  const features = [
    {
      icon: 'ri-user-heart-line',
      title: '專業師資',
      description: '外籍教師搭配中籍助教，雙語教學環境，確保學習效果'
    },
    {
      icon: 'ri-group-line',
      title: '小班制教學',
      description: '每班不超過12人，老師能充分關注每位學生的學習狀況'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全環境',
      description: '完善的安全設施與管理制度，讓家長安心託付'
    },
    {
      icon: 'ri-book-open-line',
      title: '多元課程',
      description: '結合美語教學與才藝課程，培養孩子全方位能力'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">關於威斯理美語</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            我們致力於為孩子提供最優質的美語學習環境，結合專業教學與溫馨照顧，
            讓每個孩子都能在快樂中學習，在學習中成長。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/5d07fa13d34c7ab2f2931aa373cb94d6.jpg"
              alt="快樂學習環境"
              className="rounded-lg shadow-lg object-cover w-full h-96"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-800 mb-6">我們的教育理念</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              我們相信每個孩子都是獨特的個體，擁有無限的學習潛能。透過生動有趣的教學方式，
              我們激發孩子對美語的興趣，培養他們的自信心與表達能力。
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed">
              除了語言學習，我們更注重品格教育與生活技能的培養，希望每個孩子都能成為
              具備國際視野的優秀人才。
            </p>
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                <i className="ri-award-line text-2xl text-blue-600"></i>
              </div>
              <div>
                <div className="font-bold text-gray-800">教育部立案</div>
                <div className="text-gray-600">合法立案，品質保證</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className={`${feature.icon} text-2xl text-blue-600`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-3 text-center">{feature.title}</h4>
              <p className="text-gray-600 text-center leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
